import React from 'react';
import PropTypes from 'prop-types';

import { Card } from '../../../ui';

import i18n from 'i18next';

import './actionCard.css';
import Icon from '../../ui/icon/icon';
import { classnames } from '../../../../utils/classnames';

function ActionIcon({ icon, type, size, disabled }) {
	return (
		<Icon className={classnames('neo-action-card-icon', type, {disabled: disabled})} size={size} name={icon}/>
	);
}

ActionIcon.defaultProps = {
	icon: null,
	type: null,
	disabled: false,
}
ActionIcon.propTypes = {
	icon: PropTypes.string,
	type: PropTypes.oneOf(['primary', 'inverted', 'confirm', 'delete']),
	disabled: PropTypes.bool,
};

function ActionPricing({ formattedPrice }) {
	return (
		<span className="neo-action-card-pricing">
			{formattedPrice}
		</span>
	);
}

// TODO: add actions or handle it from the back
export const ACTION_TYPE_MAPPING = {
	'primary': ['download'],
	'inverted': ['qr'],
	'confirm': ['confirm'],
	'delete': ['delete']
}

export const ACTION_SIZE_MAPPING = {
	'huge': ['delete', 'confirm'],
}

export const ACTION_ICON_MAPPING = {
	'checkSimple': ['confirm'],
	'cross': ['delete'],
	'qr': ['qr'],
	'edit': ['edit'],
	'receipt': ['download']
}

export function getAttributeForAction(actionName, attribute) {
	const lowerName = actionName.toLowerCase();
	// use attribute mapping
	const attributes = { size: ACTION_SIZE_MAPPING, type: ACTION_TYPE_MAPPING, icon: ACTION_ICON_MAPPING };
	// for each key check if action name is in array, if so return it
	return Object.keys(attributes[attribute]).find(key => attributes[attribute][key].some(shortName => lowerName.includes(shortName)));
}

export default function ActionCard({ icon, customIcon, type, size, disabled, label, description, onClick, metadata, children }) {
	const _onClick = React.useCallback(() => {
		if(disabled) {
			return;
		}

		return onClick();
	}, [disabled, onClick]);

	const { price=null, currency='EUR' } = metadata;
	const price_cents = price ? price / 100 : null;
	const formatted_price = price && new Intl.NumberFormat(i18n.language.replace("_", "-"), { style: 'currency', currency: currency, currencyDisplay: 'narrowSymbol' }).format(price_cents);

	return (
		<Card className={classnames('neo-action-card-container', {'disabled': disabled})} disabled={disabled} onClick={_onClick}>
			<div className='neo-action-card-left-container'>
				<div>
					{customIcon ? customIcon : <ActionIcon icon={icon} disabled={disabled} type={type} size={size} />}
				</div>
				<div className={classnames('neo-action-card-infos', {'custom-icon': customIcon})}>
					<span className={classnames('neo-action-card-title', {'disabled': disabled})}>{label}</span>
					{description && <span className='neo-action-card-description'>{description}</span>}
					{formatted_price ? <ActionPricing formattedPrice={formatted_price}/> : null}
					{ children }
				</div>
			</div>
			<div className='neo-action-card-right-container'>
				<div className={classnames('neo-action-card-right-icon', {'disabled': disabled})}>
					<Icon name='arrowRight' size='large'/>
				</div>
			</div>
		</Card>
	);
}

ActionCard.defaultProps = {
	icon: null,
	customIcon: null,
	type: null,
	label: null,
	description: null,
	disabled: false,
	onClick: () => {},
	metadata: {}
}
ActionCard.propTypes = {
	icon: PropTypes.string,
	customIcon: PropTypes.any,
	type: PropTypes.oneOf(['primary', 'inverted', 'confirm', 'delete']),
	label: PropTypes.node,
	description: PropTypes.node,
	disabled: PropTypes.bool,
	onClick: PropTypes.func,
	metadata: PropTypes.object
};